import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavController, ViewController } from 'ionic-angular';
import { EmailValidator } from '../../validators/email';
//import { AuthData } from '../../providers/auth-data';
import { Http, Request, RequestMethod, Headers } from '@angular/http';

declare var Mailgun;

@Component({
  selector: 'contact',
  templateUrl: 'contact.html'
})

export class ContactComponent {
    
  //  Mailgun.initialize('mg.bouboulodge.co.za', 'key-2s9o2pd07nm2q3mxu46pnqd9rnxqzc88');

   @ViewChild('signupSlider') signupSlider: any;
 
    slideOneForm: FormGroup;
    slideTwoForm: FormGroup;
    mailgunUrl: string = "mg.bouboulodge.co.za";
    mailgunApiKey: string = "key-2s9o2pd07nm2q3mxu46pnqd9rnxqzc88";

  
    submitAttempt: boolean = false;
 
    constructor(public navCtrl: NavController, public formBuilder: FormBuilder,  
    public viewCtrl: ViewController, public http: Http) {
    
      this.slideOneForm = formBuilder.group({
        firstName: ['', Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
        lastName: ['', Validators.compose([Validators.maxLength(30), Validators.pattern('[a-zA-Z ]*'), Validators.required])],
        email: ['', Validators.compose([Validators.required, EmailValidator.isValid])],
     //   password: ['', Validators.compose([Validators.minLength(6), Validators.required])]
    });
 
    this.slideTwoForm = formBuilder.group({
        privacy: ['', Validators.required],
        bio: ['']
    });    
    
    }

   
    send(recipient: string, subject: string, message: string) {

        console.log(recipient+ ':' +subject+ ':' +message)
        var headers:any = new Headers();
        var requestHeaders = headers;
        requestHeaders.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,PATCH,OPTIONS'); //TC ADDED
        requestHeaders.append("Authorization", "Basic " + this.mailgunApiKey);
        requestHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        console.log(requestHeaders);

        this.http.request(new Request({
            method: RequestMethod.Post,
            url: "https://api.mailgun.net/v3/" + this.mailgunUrl + "/messages",
            body: "from=test@example.com&to=" + recipient + "&subject=" + subject + "&text=" + message,
            headers: requestHeaders
        }))
        .subscribe(success => {
            console.log("SUCCESS -> " + JSON.stringify(success));
        }, error => {
            console.log("ERROR -> " + JSON.stringify(error));
        });
    }

    closeContactModal() {
       this.viewCtrl.dismiss();
    }

    next(){
        this.signupSlider.slideNext();
    }
 
    prev(){
        this.signupSlider.slidePrev();
    }
 
    save(){
     this.submitAttempt = true;
 
    if(!this.slideOneForm.valid){
        this.signupSlider.slideTo(0);
    } 
    else if(!this.slideTwoForm.valid){
        this.signupSlider.slideTo(1);
    }
    else {
        console.log("success!")
        console.log(this.slideOneForm.value);
        console.log(this.slideTwoForm.value);

    }
    }

}



// WEBPACK FOOTER //
// ./src/components/contact/contact.ts